import React from 'react';
import InfoCards from './Cards'
import Resources from './GetResources'
import StateTable from './Comp_State_Table'
import LineChart from './Charts/ActiveCase';
import RecLineChart from './Charts/Recovered';
import DeathLineChart from './Charts/DeathCases';
import IndiaMap from './Charts/GeoChart';

function App() {
  return(
    <main className="page bg-white" id="petratings">
    <div className="container">
      <div className="row">
        <div className="col-md-12 bg-white">
          <div className="container">
               <InfoCards />
               <br />
               <Resources />
               <StateTable />
               <br />
               <IndiaMap />
               <br />
               <LineChart/>
               <br />
                <RecLineChart />
               <br />
                <DeathLineChart />
                <br />
            </div>
        </div> 
      </div>
    </div>
   </main>     

  )
}



export default App;


